<template>
<div v-loading.fullscreen.lock="fullscreenLoading">

    <!--コンテンツ-->
    
    <main id="renew2_mypage">
      <div class="point_container">
        <div class="renew2_wrapper renew2_flex">
            <div class="servicelist">
                <ul class="servicelist__block renew2_pc">
                    <li class="servicelist__item waiting"><a href="/mypage"><img
                                src="/static/renew2_img/icon_mypagetop.svg" alt="マイページ"><br>マイページ</a></li>
                    <li class="servicelist__item waiting"><a href="/mypage/yagioffer"><img
                                src="/static/renew2_img/icon_yagioffer.svg" alt="ヤギオファー"><br>ヤギオファー</a></li>
                    <li class="servicelist__item waiting"><a href="/mypage/quickmail"><img
                                src="/static/renew2_img/icon_quickmail.svg" alt="ヤギの宅配便"><br>ヤギの宅配便</a></li>
                    <li class="servicelist__item waiting"><a href="/mypage/quickemail"><img
                                src="/static/renew2_img/icon_quickemail.svg" alt="ヤギのメール便"><br>ヤギのメール便</a></li>
                    <li class="servicelist__item onclick"><a href="/mypage/point"><img
                                src="/static/renew2_img/icon_point.svg" alt="ポイント"><br>ポイント</a></li>
                    <li class="servicelist__item waiting"><a href="/mypage/introduction"><img
                                src="/static/renew2_img/icon_recommend.svg" alt="推薦・紹介文"><br>推薦・紹介文</a></li>
                </ul>
                <div class="renew2_sp">
                    <ul class="servicelist__block renew2_sp_flex">
                        <li class="servicelist__item waiting"><a href="/mypage"><img
                                    src="/static/renew2_img/icon_yagioffer.svg" alt="ヤギオファー"><br>ヤギオファー</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/yagioffer"><img
                                    src="/static/renew2_img/icon_quickmail.svg" alt="ヤギの宅配便"><br>ヤギの宅配便</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/quickmail"><img
                                    src="/static/renew2_img/icon_quickemail.svg" alt="ヤギのメール便"><br>ヤギのメール便</a></li>
                        <li class="servicelist__item onclick"><a href="/mypage/point"><img
                                    src="/static/renew2_img/icon_point.svg" alt="ポイント"><br>ポイント</a></li>
                        <li class="servicelist__item waiting"><a href="m/mypage/introduction"><img
                                    src="/static/renew2_img/icon_recommend.svg" alt="推薦・紹介文"><br>推薦・紹介文</a></li>
                    </ul>
                </div>
            </div>
            <div class="mypage_contents">
                <div class="renew2_flex lead">
                    <h2>ポイント</h2>
                    <a href="" target="_blank" class="">ポイントについて</a>
                </div>
                <p class="lead">獲得したポイントを他社のポイントサービスと交換することができます。</p>
                <div class="memo">
                    <p>※1pt＝1円相当</p>
                    <p>※登録のメールアドレスに交換用のURLとコードが届きますので、大切に保管ください。</p>
                </div>
                <div class="point_block">
                    <ul class="point_block__list">
                        <li class="renew2_flex point_block__item">
                            <p class="point-left">保有ポイント</p>
                            <p class="point-right">10,000<span>pt</span></p>
                        </li>
                        <li class="renew2_flex point_block__item">
                            <p class="point-left">交換可能ポイント</p>
                            <p class="point-right">8,000<span>pt</span></p>
                        </li>
                        <li class="renew2_flex point_block__item">
                            <p class="point-left">交換可能サービス</p><p class="point-right">
                            <img src="/static/renew2_img/point_img_20231031.png" alt="ポイント交換サービス一覧"></p>
                        </li>
                    </ul>
                </div>
                <div class="exchange_block">
                    <p>交換するポイントを選択してください。</p>
                    <label for="" class="selectbox-003">
                        <select name="points">
                            <option>1000<span>pt</span></option>
                            <option>2000<span>pt</span></option>
                            <option>3000<span>pt</span></option>
                        </select>
                    </label>
                    <p>交換予定ポイント<span>900</span>pt</p>
                    <p class="memo">手数料<span>100</span>pt</p>
                </div>
                <div class="content-wrapper" style="width: 100%;">
                    <a href="" target="_blank" class="mes-confirm">ポイントを交換する</a>
                </div>

                <div>
                    <p>※各デジタルギフトはデジコを経由して交換いただけます。デジコの使い方は<br><a href="https://user.digi-co.net/use">こちら</a></p>
                    <p>© 2023 iTunes K.K. All rights reserved.</p>
                    <p>※Goole Play および Google Play ロゴは Google LLC の商標です。</p>
                    <p>※本プログラムは株式会社Yagishによる提供です。本プログラムについてのお問い合わせは Amazon ではお受けしておりません。株式会社Yagishについては<br>
                    <a href="https://www.yagish.jp/contact/">こちら</a><br>までお願いいたします。</p>
                    <p>※Amazon、Amazon.co.jp およびそれらのロゴは Amazon.com, Inc.またはその関連会社の商標です。</p>
                    <p>※LINE Pay残高のお受け取りには、LINE Payアカウントが必要です。</p>
                    <p>※LINE Pay残高のお受け取りには、お客様のLINE Pay ナンバーをご入力いただく必要がございます。</p>
                    <p>※PeXから外部への交換には手数料がかかる場合がございます。</p>
                    <p>※「QUOカードPay」もしくは「クオ・カード ペイ」およびそれらのロゴは 株式会社クオカードの登録商標です。</p>
                </div>
                <div class="renew2_sp">
                    <a href="mypage_top.html" class="servicelist__mypage"><img src="/static/renew2_img/icon_mypagetop.svg"
                            alt="マイページ">マイページに戻る</a>
                </div>
            </div>
        </div>
      </div>

      <!--SP-->
      <!--<div class="top_container renew2_sp">
              <div class="renew2_wrapper">
                  <h2>マイページ</h2>
                  
                  
                  
                  <div class="servicelist">
                      <h3>各種サービスのご利用状況</h3>
                      <ul class="renew2_sp_flex servicelist__block">
                          <li><a href=""><img src="/static/renew2_img/icon_yagioffer.svg" alt="ヤギオファー"><br>ヤギオファー</a></li>
                          <li><a href=""><img src="/static/renew2_img/icon_quickmail.svg" alt="ヤギの宅配便"><br>ヤギの宅配便</a></li>
                          <li><a href=""><img src="/static/renew2_img/icon_quickemail.svg" alt="ヤギのメール便"><br>ヤギのメール便</a></li>
                          <li><a href=""><img src="/static/renew2_img/icon_recommend.svg" alt="推薦・紹介文"><br>推薦・紹介文</a></li>
                      </ul>
                  </div>
              </div>
          </div>-->
  </main>

</div>
</template>

<style lang="css" src="@/assets/css/renew2_mypage.css"></style>


<style scoped>
    #renew2_mypage .point_container {
        margin-bottom: 50px;
    }

    #renew2_mypage .point_container .servicelist__block {
        text-align: center;
    }

    #renew2_mypage .point_container .servicelist__block .onclick {
        background: #EEF5E8;
        border-radius: 10px 0 0 10px;
    }

    #renew2_mypage .point_container .servicelist__block .waiting {
        opacity: 0.5;
    }

    #renew2_mypage .point_container .servicelist__block .waiting:hover {
        opacity: 1;
    }

    #renew2_mypage .point_container .servicelist__item {
        font-size: 0.5rem;
        padding: 15px;
        white-space: nowrap;
    }

    #renew2_mypage .point_container .servicelist__item a {
        color: #004D40;
    }

    #renew2_mypage .point_container .mypage_contents {
        background: #EEF5E8;
        padding: 35px 50px;
        width: 100%;
        border-radius: 10px 10px 10px 10px;
    }

    #renew2_mypage .point_container .mypage_contents h2{
        font-size: 1.4rem;
        font-weight: 700;
        margin-right: 15px;
        text-align: left;
        padding: 0;
        margin: 0 10px 0 0;
    }

    #renew2_mypage .point_container .mypage_contents .lead{
        align-items: center;
        margin-bottom: 10px;
    }

    #renew2_mypage .point_container .mypage_contents .memo {
        font-size: 0.8rem;
    }

    #renew2_mypage .point_container .mypage_contents a {
        color: #004D40;
        position: relative;
        margin-left: 5px;
    }

    #renew2_mypage .point_container .mypage_contents a:before {
        position: absolute;
        content: url(/static/renew2_img/icon_link_toggle.svg);
        left: -8px;
    }

    #renew2_mypage .point_container .mypage_contents .point_block__list {
        padding: 30px 20px;
        border-radius: 10px;
        margin: 20px 10px 0 0;
    }

    #renew2_mypage .point_container .mypage_contents .point_block__item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding: 20px 0;
        border-bottom: 1px solid #fff;
    }

    #renew2_mypage .point_container .mypage_contents .point_block__item:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }

    #renew2_mypage .point_container .mypage_contents .point_block__item .point-left {
        width: 50%;
    }

    #renew2_mypage .point_container .mypage_contents .exchange_block {
        text-align: center;
    }

    #renew2_mypage .point_container .mypage_contents .exchange_block .memo {
        font-size: 0.8rem;
    }

    #renew2_mypage .point_container .mypage_contents .mes-confirm {
        background: #fff;
        padding: 10px 30px;
        width: 100%;
        border-radius: 40px;
        border: 1px solid #e3165c;
    }

    #renew2_mypage .point_container .mypage_contents .mes-confirm::before{
        display: none;
    }

    #renew2_mypage .point_container .mypage_contents .exchange_block .selectbox-003 {
        display: inline-flex;
        align-items: center;
        position: relative;
        margin-bottom: 10px;
    }

    #renew2_mypage .point_container .mypage_contents .exchange_block .selectbox-003::after {
        position: absolute;
        right: 15px;
        width: 10px;
        height: 7px;
        background-color: #535353;
        clip-path: polygon(0 0, 100% 0, 50% 100%);
        content: '';
        pointer-events: none;
    }

    #renew2_mypage .point_container .mypage_contents .exchange_block .selectbox-003 select {
        appearance: none;
        min-width: 230px;
        height: 2.8em;
        padding: .4em calc(.8em + 30px) .4em .8em;
        border: 1px solid #cccccc;
        border-radius: 3px;
        background-color: #fff;
        color: #333333;
        font-size: 1em;
        cursor: pointer;
    }

    @media screen and (max-width: 640px) {
        #renew2_mypage .point_container {
            padding-top: 10px;
        }

        #renew2_mypage .point_container h2 {
            font-size: 1.4rem;
            font-weight: bold;
            margin-bottom: 10px;
        }

        #renew2_mypage .point_container .mypage_contents {
            width: auto;
            padding: 15px;
            padding-bottom: 50px;
            border-radius: 10px;
        }

        #renew2_mypage .point_container .mypage_contents h2 {
            font-size: 1.4rem;
            font-weight: bold;
            margin-right: 10px;
        }

        #renew2_mypage .point_container .mypage_contents .lead {
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            margin-bottom: 10px;
        }

        #renew2_mypage .point_container .servicelist__mypage {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            font-size: 0.6rem;
            color: #004D40;
            margin-top: 30px;
        }

        #renew2_mypage .point_container .servicelist__mypage img {
            width: 20px;
            margin-right: 5px;
        }

        #renew2_mypage .point_container .servicelist__mypage::before {
            display: none;
        }

        #renew2_mypage .point_container .servicelist__block {
            margin-bottom: 10px;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            -webkit-box-align: end;
            -ms-flex-align: end;
            align-items: flex-end;
        }

        #renew2_mypage .point_container .servicelist__block .onclick {
            border-radius: 10px;
        }

        #renew2_mypage .point_container .servicelist__item {
            padding: 10px;
        }

        #renew2_mypage .point_container .mypage_contents {
            padding: 15px;
            padding-bottom: 50px;
            border-radius: 10px;
        }

        #renew2_mypage .point_container .mypage_contents .yagioffer_block__list {
            width: 100%;
        }

        #renew2_mypage .point_container .mypage_contents .yagioffer_block__item {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        }
    }
</style>

<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import firebase from 'firebase/app'

export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
		  fullscreenLoading: true,
      recentEdit: {
        FormatId: ''
      },
      dialogVisible:false,
      selectedYagiOfferData:{},
      yagiPointList: [],
      previewLoading: false,
      yagiOfferUnreadmessageList: [],
      chatURL: ''
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    openYagiOfferDetailDialog: function (offer_id, read_flag) {
      const app = this
      if (read_flag != '1') {
        const app = this
        const formData = new FormData()
        formData.append('offer_id', offer_id)
        formData.append('uuid', app.$firebase.user.uid)

        this.$axios
          .post(this.$varuna.endPoints.readYagiOffer, formData, {timeout: 60000})
          .then(function (response) {
            for(let _item of app.yagiOfferData.offer_list){
              if (_item.offer_id == offer_id) {
                _item.read_flag = '1'
              }
            }
          })
          .catch(function (error) {})
          .finally(function () {})
      }
    },
  },
  created: function () {
    const app = this
    // console.log(this.$route.query.mynavi)
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {    
        console.log('logined')
        const formData = new FormData()
        formData.append('access_id', '')
        formData.append('uuid', app.$firebase.user.uid)
        formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP': 'PC')
        formData.append('version', '2')
        formData.append('reqflg', '2')
        this.$axios
          .post(this.$varuna.endPoints.getPointHistory, formData, {timeout: 60000})
          .then(function (response) {
            app.yagiPointList = response.data
            console.error(app.yagiPointList)
          })
	      this.fullscreenLoading = false

      } else {
        this.$router.push('/login')
      }
    })
  },
  beforeMount: function () {
  },
  destroyed: function () {
  }
}
</script>
